const desktop = "@media screen and (min-width:1024px)";
const tablet = "@media screen and (max-width:1023px)";
const mobile = "@media screen and (max-width:767px)";

export default (theme) => {
  const isDark = theme.palette.mode === "dark";
  const popBg = isDark ? "#14171C" : "#FFFFFF";
  const headerHoverBg = isDark ? "#14171C" : "#F6F8F9";
  const menuHoverBg = isDark ? "#1F2228" : "#F6F8F9";
  const borderColor = theme.palette.grey[10];
  const text100 = theme.palette.text[100];
  const text60 = theme.palette.text[60];
  const text25 = theme.palette.text[25];
  const primary = theme.palette.primary.main;
  const primaryHover = theme.palette.primary.hover || theme.palette.primary.main;

  return {
    header: {
      height: 64,
      padding: "0 24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      background: theme.palette.commonBg,
      color: text100,
      boxSizing: "border-box",
      position: "fixed",
      width: "100%",
      left: 0,
      top: 0,
      zIndex: 20,
      [mobile]: {
        padding: "0 16px",
        gap: 8,
      },
    },
    headerLeft: {
      minWidth: 0,
      flex: "1 1 auto",
      display: "flex",
      alignItems: "center",
      height: "100%",
      gap: 12,
      [tablet]: {
        gap: 12,
      },
    },
    logo: {
      display: "inline-flex",
      flex: "0 0 auto",
      "& a": {
        display: "inline-flex",
        alignItems: "center",
      },
      "& img": {
        width: "auto",
        height: 24,
        display: "block",
        [mobile]: {
          height: 20,
        },
      },
    },
    nav: {
      minWidth: 0,
      display: "flex",
      alignItems: "center",
      height: "100%",
      gap: 0,
      overflow: "visible",
      [tablet]: {
        display: "none",
      },
    },
    navItem: {
      height: "100%",
      display: "inline-flex",
      alignItems: "center",
      flex: "0 0 auto",
      position: "relative",
    },
    navLink: {
      height: "100%",
      display: "inline-flex",
      alignItems: "center",
      position: "relative",
      gap: 4,
      padding: "0 12px",
      color: text100,
      fontSize: 14,
      lineHeight: "20px",
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: "color .2s, background .2s",
      border: 0,
      background: "transparent",
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        height: 2,
        background: "transparent",
      },
      "&:hover, &.is-open": {
        color: primary,
        background: headerHoverBg,
        "&::before": {
          background: primary,
        },
        "& .more": {
          color: primary,
          transform: "rotate(-180deg)",
        },
      },
      "& .more": {
        width: 14,
        height: 14,
        transition: "transform .2s",
      },
      "@media screen and (max-width:1240px)": {
        padding: "0 14px",
      },
    },
    fees: {
      marginLeft: 8,
      flex: "0 0 auto",
    },
    popoverHost: {
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      height: "100%",
    },
    popoverContent: {
      position: "absolute",
      display: "none",
      top: "100%",
      right: 0,
      zIndex: 50,
      paddingTop: 0,
    },
    popoverLeft: {
      left: -16,
      right: "auto",
    },
    showPopover: {
      display: "block !important",
    },
    navMenu: {
      width: 367,
      padding: 16,
      background: popBg,
      borderRadius: "0 0 10px 10px",
      boxShadow: "0 24px 44px rgba(0, 0, 0, .18)",
      display: "flex",
      flexDirection: "column",
      gap: 12,
    },
    navMenuItem: {
      display: "flex",
      alignItems: "center",
      gap: 16,
      minHeight: 64,
      padding: "8px 16px",
      borderRadius: 8,
      color: text100,
      "&:hover": {
        background: menuHoverBg,
        color: text100,
      },
    },
    navMenuIcon: {
      width: 40,
      height: 40,
      flex: "0 0 auto",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 8,
      border: `1px solid ${borderColor}`,
      background: "transparent",
      color: text100,
      "& img, & svg": {
        width: 24,
        height: 24,
        display: "block",
      },
    },
    navMenuText: {
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      gap: 4,
    },
    title: {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "21px",
      color: text100,
      position: "relative",
    },
    subTitle: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: "18px",
      color: text60,
    },
    option: {
      flex: "0 0 auto",
      display: "flex",
      height: "100%",
      alignItems: "center",
      gap: 16,
      fontSize: 14,
      [mobile]: {
        gap: 12,
      },
      "@media screen and (max-width:374px)": {
        gap: 8,
      },
    },
    actionGroup: {
      display: "flex",
      alignItems: "center",
      gap: 16,
      height: "100%",
      flex: "0 0 auto",
      [mobile]: {
        gap: 12,
      },
      "@media screen and (max-width:374px)": {
        gap: 8,
      },
    },
    loginAction: {
      height: 32,
      padding: 0,
      border: 0,
      background: "transparent",
      color: text100,
      fontSize: 14,
      lineHeight: "32px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      "&:hover": {
        color: primary,
      },
      [mobile]: {
        display: "none",
      },
    },
    registerBtn: {
      minWidth: 80,
      height: 32,
      padding: "0 16px",
      borderRadius: "16px !important",
      borderColor: `${primary} !important`,
      background: `${primary} !important`,
      color: `${theme.palette.sta.text[9]} !important`,
      boxShadow: "none !important",
      flex: "0 0 auto",
      whiteSpace: "nowrap",
      "&:hover": {
        color: `${theme.palette.sta.text[9]} !important`,
        borderColor: `${theme.palette.sta.brand.hover} !important`,
        background: `${theme.palette.sta.brand.hover} !important`,
      },
      [mobile]: {
        minWidth: 76,
        padding: "0 12px",
      },
    },
    divider: {
      width: 1,
      height: 24,
      flex: "0 0 auto",
      background: borderColor,
    },
    iconButton: {
      width: 24,
      height: 64,
      padding: 0,
      border: 0,
      background: "transparent",
      color: text100,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      flex: "0 0 auto",
      lineHeight: 1,
      "& svg": {
        width: 24,
        height: 24,
        display: "block",
        padding: 2,
        boxSizing: "border-box",
      },
      "& .MuiBadge-root": {
        display: "inline-flex",
        color: "inherit",
      },
      "&:hover": {
        color: primary,
      },
    },
    avatarButton: {
      color: text100,
      "&:hover": {
        color: text100,
      },
    },
    menu: {
      background: popBg,
      boxShadow: "0 18px 40px rgba(0, 0, 0, .16)",
      borderRadius: 8,
      padding: 20,
      maxHeight: 500,
      minWidth: 307,
      overflow: "auto",
    },
    downloadMenu: {
      background: popBg,
      boxShadow: "0 18px 40px rgba(0, 0, 0, .16)",
      borderRadius: 8,
      padding: 20,
      maxHeight: 500,
      minWidth: 184,
      overflow: "auto",
    },
    menuItem: {
      width: "100%",
      minWidth: 184,
      minHeight: 44,
      display: "flex",
      alignItems: "center",
      gap: 10,
      textAlign: "left",
      padding: "10px 12px",
      cursor: "pointer",
      boxSizing: "border-box",
      borderRadius: 6,
      border: 0,
      background: "transparent",
      color: text100,
      fontSize: 14,
      "& .icon": {
        color: text100,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "0 0 auto",
        "& svg": {
          width: 24,
          height: 24,
          padding: 2,
          boxSizing: "border-box",
        },
      },
      "&:hover": {
        background: menuHoverBg,
        color: text100,
      },
    },
    menuItem2: {
      marginBottom: 4,
    },
    qrcode: {
      textAlign: "center",
      width: 174,
      "& img": {
        width: 150,
        height: 150,
        borderRadius: 4,
        display: "block",
        margin: "0 auto",
      },
      "& p": {
        margin: "10px 0 0",
        fontSize: 14,
        color: text60,
      },
      "& a": {
        width: 150,
        height: 37,
        margin: "10px auto 0",
        borderRadius: 4,
        background: primary,
        color: `${theme.palette.sta.text[9]} !important`,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14,
        lineHeight: "18px",
        "&:hover": {
          background: theme.palette.sta.brand.hover,
        },
      },
    },
    messageList: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      padding: "0 0 0 20px",
      margin: 0,
      "& a": {
        color: text100,
        lineHeight: "21px",
        display: "block",
        "&:hover": {
          color: primary,
        },
      },
    },
    messageItem: {
      listStyle: "disc",
      width: 300,
      color: text100,
      "&:hover": {
        color: primary,
      },
    },
    messageMore: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: 12,
      "& a": {
        display: "flex",
        alignItems: "center",
        color: primary,
        gap: 4,
      },
    },
    langTit: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      minWidth: 300,
      gap: 10,
      color: text60,
      "& .tit": {
        fontSize: 14,
        lineHeight: "21px",
        marginBottom: 10,
        padding: "8px 12px",
      },
    },
    langCon: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      minWidth: 300,
      gap: 10,
      maxHeight: 240,
      overflowY: "auto",
      "& ul": {
        minWidth: 0,
        margin: 0,
        padding: 0,
        color: text100,
        "& li": {
          listStyleType: "none",
          cursor: "pointer",
          textAlign: "left",
          minWidth: 140,
          padding: "0 12px",
          fontSize: 14,
          lineHeight: "16px",
          height: 40,
          boxSizing: "border-box",
          borderRadius: 6,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 6,
          gap: 8,
          "&.select, &:hover": {
            color: primary,
            backgroundColor: menuHoverBg,
          },
          "& svg": {
            color: text100,
          },
        },
      },
    },
    compactLanguageMenu: {
      minWidth: 0,
      padding: 0,
      border: 0,
      boxShadow: "none",
      background: "transparent",
      "& $langTit, & $langCon": {
        minWidth: 0,
      },
    },
    userHeader: {
      display: 'flex',
      alignItems: 'center',
      borderBottom: `1px solid ${theme.palette.sta.divider[1]}`,
      paddingBottom: 10,
      marginBottom: 4,
    },
    userinfo: {
      lineHeight: "17px",
      textAlign: "left",
      fontSize: 12,
      padding: "8px 12px 12px",
      "& h3": {
        cursor: "pointer",
        lineHeight: "24px",
        fontSize: 16,
        margin: "0 0 4px",
        color: text100,
        "& a": {
          color: text100,
        },
      },
      "& p": {
        cursor: "default",
        display: "flex",
        alignItems: "center",
        margin: 0,
        color: text60,
        "& button": {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: 8,
          padding: 0,
          border: 0,
          background: "transparent",
          color: text25,
          cursor: "pointer",
          "&:hover": {
            color: primary,
          },
        },
      },
    },
    userMenuText: {
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
    },
    vip: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      padding: "0 8px",
      height: 22,
      background: menuHoverBg,
      borderRadius: 22,
      lineHeight: "18px",
      color: text60,
      fontSize: 12,
      margin: "6px 0 0",
      whiteSpace: "nowrap",
      "& img": {
        width: 16,
        height: 16,
        marginRight: 0,
      },
    },
    badgeDot: {
      background: "#EB2F7F",
      minWidth: 6,
      height: 6,
    },
    morePanel: {
      width: 320,
      maxWidth: "calc(100vw - 24px)",
      maxHeight: "calc(100vh - 88px)",
      overflowY: "auto",
      padding: 12,
      background: popBg,
      color: text100,
      border: `1px solid ${borderColor}`,
      borderRadius: 8,
      boxShadow: "0 18px 40px rgba(0, 0, 0, .16)",
      [mobile]: {
        width: "100%",
        maxWidth: "100%",
        maxHeight: "100vh",
        minHeight: "100%",
        border: 0,
        borderRadius: 0,
        boxShadow: "none",
      },
    },
    moreSection: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      padding: "8px 0",
      borderBottom: `1px solid ${borderColor}`,
      "&:last-child": {
        borderBottom: 0,
      },
    },
    moreNavGroup: {
      display: "flex",
      flexDirection: "column",
    },
    moreItem: {
      width: "100%",
      minHeight: 44,
      padding: "0 12px",
      border: 0,
      borderRadius: 6,
      background: "transparent",
      color: text100,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      fontSize: 14,
      lineHeight: "20px",
      cursor: "pointer",
      textAlign: "left",
      boxSizing: "border-box",
      "&:hover": {
        background: menuHoverBg,
        color: text100,
      },
      "& .more": {
        width: 14,
        height: 14,
        color: text60,
      },
    },
    moreItemTitle: {
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      minWidth: 0,
      "& svg": {
        width: 20,
        height: 20,
        padding: 2,
        boxSizing: "border-box",
      },
    },
    moreSubList: {
      display: "flex",
      flexDirection: "column",
      padding: "0 0 6px 20px",
    },
    moreSubItem: {
      minHeight: 38,
      padding: "7px 12px",
      borderRadius: 6,
      color: text60,
      display: "flex",
      flexDirection: "column",
      gap: 2,
      fontSize: 13,
      lineHeight: "18px",
      "& small": {
        color: text25,
        fontSize: 12,
        lineHeight: "16px",
      },
      "&:hover": {
        background: menuHoverBg,
        color: text100,
      },
    },
    mobileMask: {
      display: "none",
      [tablet]: {
        position: "fixed",
        inset: 0,
        zIndex: 40,
        background: "rgba(0, 0, 0, .45)",
      },
    },
    mobileMaskOpen: {
      [tablet]: {
        display: "block",
      },
    },
    mobilePanel: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      width: "min(320px, 100vw)",
      zIndex: 41,
      transform: "translateX(100%)",
      transition: "transform .2s ease",
      background: popBg,
      [desktop]: {
        display: "none",
      },
    },
    mobilePanelOpen: {
      transform: "translateX(0)",
    },
  };
};
